<template>
    <nav class="alerts-nav" >
        <tab :handleClick="setLeft" text="Current" :data-selected="left" />
        <tab :handleClick="setRight" text="Past" :data-selected="!left" data-right />
    </nav>
</template>

<script>
    import Tab from "@/components/ui/nav/Tab"
	export default {
        name: "alerts-nav",
        props: ['activeLeft'],
        components: { Tab },
        data () {
            return {
                left: this.activeLeft
            }
        },
        methods: {
            setLeft () { 
                this.left = true 
                this.$emit('change', 'left')
            },
            setRight () { 
                this.left = false 
                this.$emit('change', 'right')
            }
        }
	}

</script>

<style lang="scss" scoped>

	nav.alerts-nav {
		width: 100%; height: 50px;
        text-align: center;
        line-height: 153px;
        background-color: #f7f7f7;
        font-size: 24px;
	}

</style>



// WEBPACK FOOTER //
// src/components/ui/nav/AlertsNav.vue